var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 36,
    height: 36,
    rx: 9,
    fill: "#EFF8D8",
    fillOpacity: 0.5,
    stroke: "#EFF8D8",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0607 6.97799C19.4749 6.3922 18.5251 6.3922 17.9393 6.97799L8.3934 16.5239C7.80761 17.1097 7.80761 18.0595 8.3934 18.6453C8.97918 19.231 9.92893 19.231 10.5147 18.6453L19 10.16L27.4853 18.6453C28.0711 19.231 29.0208 19.231 29.6066 18.6452C30.1924 18.0595 30.1924 17.1097 29.6066 16.5239L20.0607 6.97799ZM20.5 29.231L20.5 8.03865L17.5 8.03865L17.5 29.231L20.5 29.231Z",
    fill: "#EFF8D8"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpButton);
export default __webpack_public_path__ + "static/media/up-button.5eb9d5a0830f71c11b5fb63e7e7a9f61.svg";
export { ForwardRef as ReactComponent };